import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button } from "@wojo/ui";
import cn from "clsx";
import React from "react";
import { useTourPageContext } from "../../_client/context";
import { scrollToSection } from "../../_client/hooks";
import styles from "./TripBuilderButtonBanner.module.scss";

type TripBuilderButtonBannerProps = {
    isVisible: boolean;
};

export const TripBuilderButtonBanner: React.FC<
    TripBuilderButtonBannerProps
> = ({ isVisible }) => {
    const { productPage } = useI18n("productPage");
    const { navRef } = useTourPageContext();
    const tripBuilderButtonLabel =
        productPage.tourHero.tripBuilderButtonLabel.l();

    return (
        <div
            className={cn(styles.banner, {
                [styles["banner--hidden"]]: !isVisible,
            })}
        >
            <Button
                variant="secondary"
                tag="a"
                href="#tripbuilder"
                onClick={(e) => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            event: "track",
                            ga4_object: "ELEMENT",
                            ga4_action: "CLICKED",
                            elementType: "button",
                            clickText: tripBuilderButtonLabel,
                        },
                    });
                    scrollToSection(
                        e as React.MouseEvent<HTMLAnchorElement>,
                        navRef,
                    );
                }}
            >
                {tripBuilderButtonLabel}
            </Button>
        </div>
    );
};
